import { useCountdownStore } from "../store/useCountdownStore";
import { useOrderStore } from "../store/useOrderStore";

export const handlePaymentSuccessService = () => {
  const { startCountdown } = useCountdownStore.getState();
  const { activeOrderId, clearActiveOrderId, selectedChanelId } =
    useOrderStore.getState();
  clearActiveOrderId();

  // Start a 10-second countdown and set the redirect path
  startCountdown(10, `/order/${activeOrderId}/${selectedChanelId}`);
};
